import api, { setToken } from '../index';

export function vocabularyWords(data) {
  setToken(data.token);

  return api.get('/vocabulary/words', { params: { w: data.w, u: data.u || undefined } });
}

export function vocabularyUnlock(data) {
  setToken(data.token);

  return api.post('/vocabulary/unlock', { password: data.password });
}

export function vocabularySpeechResult(data) {
  setToken(data.token);

  return api.post('/vocabulary/speech-result', {
    w: data.w,
    word_id: data.wordId,
    verdict: data.verdict,
    heard: data.heard || undefined,
  });
}
